import {StyleRepository} from '@domain/model/Style/StyleRepository';

const GetQuizId = (repository: StyleRepository): Promise<string> => {
  return repository.getQuizId();
};

export {GetQuizId};
